import { allMovies } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';

export default function LatestSection() {
  const latestMovies = allMovies.sort(
    (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
  );

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6 md:mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">实时更新，随时畅享最新影视资源</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="/category/all"
            className="inline-flex items-center gap-2 px-6 py-3 border border-background-200/70 hover:border-primary-300 text-foreground-700 hover:text-primary-500 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            浏览全部影视 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}